module.exports = __webpack_public_path__ + "img/wheat-x.f8061a52.png";